<!-- Content will be projected here via projectableNodes -->
<div class="fullscreen-wrapper">
    <div class="header-section d-flex justify-content-between align-items-center">
        <!-- Product Name -->
        @if (productName) {
            <h1 class="product-name">
                {{ productName }}
            </h1>
        }

        <!-- close icon -->
        <img [src]="IMAGE_URLS.closeIconDark" class="close-icon" (click)="onClose()" />
    </div>
    <div class="centered-content">
        <ng-content></ng-content>
    </div>
</div>